import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { RadioSelectOptions } from 'interfaces/SelectOptions.interface.ts';
import { number, object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Nullable } from 'interfaces/Nullable.ts';

export type DBModalSettings = {
  incidentOptions: RadioSelectOptions[];
  groupOptions: RadioSelectOptions[];
  applicantsOptions: RadioSelectOptions[];
  incident: Nullable<number>;
  dataGathering: string;
  group: string | number;
  applicant: string | number;
};

export const defaultValues: DBModalSettings = {
  incidentOptions: [],
  groupOptions: [],
  applicantsOptions: [],
  incident: null,
  dataGathering: '',
  group: '',
  applicant: '',
};

function useDBModalSettingsForm(isPalmettoAdmin: boolean) {
  const validationSchema = useMemo(
    () =>
      object().shape({
        incident: number().required('A viewing incident is required'),
        // *: Only an Administrator can set the data gathering incident, so a
        // *: non-admin is not held to it when their group has none selected yet
        dataGathering: isPalmettoAdmin
          ? string().required('A data gathering incident is required')
          : string(),
        group: string().required('A group is required'),
      }),
    [isPalmettoAdmin]
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useForm<any>({ defaultValues, resolver: yupResolver(validationSchema) });
}

export default useDBModalSettingsForm;
